import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiButtonModule } from "../button/button.module";
import { UiIconModule } from "../icon/icon.module";
import { UiAlertComponent } from "./alert.component";

@NgModule({
  imports: [CommonModule, NzOutletModule, UiIconModule, UiButtonModule],
  declarations: [UiAlertComponent],
  exports: [UiAlertComponent],
})
export class UiAlertModule {}
